import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useQueryString } from './useQueryString';

const EVENT_PREVIEW_KEY = 'previewEventID';

export const useEventPreview = () => {
  const queryClient = useQueryClient();
  const [eventIdFromUrl, setEventIdInUrl] = useQueryString(EVENT_PREVIEW_KEY, null, true);

  useQuery({
    queryKey: [EVENT_PREVIEW_KEY],
    queryFn: () => eventIdFromUrl,
    initialData: eventIdFromUrl,
  });

  useEffect(() => {
    queryClient.setQueryData([EVENT_PREVIEW_KEY], eventIdFromUrl ?? null);
  }, [eventIdFromUrl, queryClient]);

  const openEventModal = (id: number) => {
    const idStr = id.toString();
    queryClient.setQueryData([EVENT_PREVIEW_KEY], idStr);
    setEventIdInUrl(idStr);
  };

  const closeEventModal = () => {
    queryClient.setQueryData([EVENT_PREVIEW_KEY], null);
    // Dismiss (replaceState) rather than push: the closed URL equals the base page, so a pushState
    // entry would make Back reopen the just-closed modal and pollute history on repeated open/close.
    setEventIdInUrl(undefined, false);
  };

  const eventId = queryClient.getQueryData<string | null>([EVENT_PREVIEW_KEY]);
  const eventModalIsOpened = !!eventId;

  return { openEventModal, closeEventModal, eventId, eventModalIsOpened };
};
